module.exports = __webpack_public_path__ + "static/media/empty_notification_icon.2849083f.svg";